import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMessage, setProfil } from "../../redux";
import "./style.css"

function Home() {
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);
    const profil = useSelector(state => state.profil);

    const [moreFilters, setMoreFilters] = useState(false);
    const [showProfil, setShowProfil] = useState(null);
    const [searchBar, setSearchBar] = useState('');
    const [filters, setFilters] = useState({
        profession: [],
        patientComTool: [],
        adminComTool: [],
        interproTool: [],
        meetingTool: [],
        urgentContact: [],
        dailyContact: [],
        weeklyContact: [],
        targetAudiences: []
    });

    useEffect(() => {
        const fetchUsers = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/users/get`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
            });
            const res = await req.json();
            dispatch(setMessage());

            if (req.status !== 200) {
                localStorage.removeItem('email');
                localStorage.removeItem('password');
                sessionStorage.removeItem('email');
                sessionStorage.removeItem('password');
                window.location.reload();
                return;
            }
            setUsers(res);
        }
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        fetchUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteredUsers = users.filter(user => {
        const search = searchBar.toLowerCase();

        // 🔍 Recherche globale
        const matchSearch =
            user.lastName?.toLowerCase().includes(search) ||
            user.firstName?.toLowerCase().includes(search) ||
            user.profession?.toLowerCase().includes(search) ||
            user.mainLocation?.toLowerCase().includes(search) ||
            user.secondaryLocations?.toLowerCase().includes(search) ||
            user.proPhone?.toLowerCase().includes(search) ||
            user.secretaryPhone?.toLowerCase().includes(search) ||
            user.proEmail?.toLowerCase().includes(search) ||
            user.secureProEmail?.toLowerCase().includes(search);

        // 🎯 Filtre profession (multi choix)
        const matchProfession =
            filters.profession.length === 0 ||
            filters.profession.some(p =>
                p.toLowerCase() === user.profession?.toLowerCase()
            );

        // 🧠 helper pour tableaux
        const includesOne = (userArray = [], filterArray = []) =>
            filterArray.length === 0 ||
            filterArray.some(f =>
                userArray.some(u => u.toLowerCase().includes(f.toLowerCase()))
            );

        // 🔽 filtres avancés
        const matchAdvanced =
            includesOne(user.patientComTool, filters.patientComTool) &&
            includesOne(user.adminComTool, filters.adminComTool) &&
            includesOne(user.interproTool, filters.interproTool) &&
            includesOne(user.meetingTool, filters.meetingTool) &&
            includesOne(user.urgentContact, filters.urgentContact) &&
            includesOne(user.dailyContact, filters.dailyContact) &&
            includesOne(user.weeklyContact, filters.weeklyContact) &&
            includesOne(user.targetAudiences, filters.targetAudiences);

        return matchSearch && matchProfession && matchAdvanced;
    });

    const requestAccess = async (_id) => {
        dispatch(setMessage('Chargement en cour, merci de patienter'));

        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/request-access/${_id}`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
        });
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) alert(res.message);

        if (req.status === 404) {
            localStorage.removeItem('email');
            localStorage.removeItem('password');
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('password');
            window.location.reload();
            return;
        }

        setTimeout(() => {
            dispatch(setMessage('Votre demande à été envoyé avec succès'));
            setShowProfil(null);

            setTimeout(() => dispatch(setMessage()), 2000);
        }, 500);
    }

    return (
        <div className="page_home">
            <div className="options">
                <div className="search_bar">
                    <input
                        type="text"
                        placeholder="Nom / Prénom / Profession / Lieu..."
                        value={searchBar}
                        onChange={(e) => setSearchBar(e.target.value)}
                    />
                    <i className="fas fa-magnifying-glass"></i>
                </div>

                {/* PROFESSION */}
                <div className="filters_bar">
                    {[
                        "Aide soignante", "Diététicien", "Educateur spécialisé", "Ergothérapeute", 
                        "Infirmier / IDE", "Kinésithérapeute", "Médecin", "Orthophoniste", "Ostéopathe", 
                        "Pédicure-podologue", "Pharmacien", "Psychologue", "Sage-femme", "Sophrologue"
                    ].map((prof) => (
                        <button
                            key={prof}
                            className={`filter_btn ${filters.profession.includes(prof) ? "active" : ""}`}
                            onClick={() => {
                                setFilters({
                                    ...filters,
                                    profession: filters.profession.includes(prof)
                                        ? filters.profession.filter(p => p !== prof)
                                        : [...filters.profession, prof]
                                });
                            }}
                        >
                            {prof}
                        </button>
                    ))}
                </div>

                <button
                    className="filter_more_btn"
                    onClick={() => setMoreFilters(!moreFilters)}
                >
                    {moreFilters ? 'Moin' : 'Plus'} de filtre
                </button>
            </div>

            {moreFilters && (
                <div className="more_filters">

                    {/* Outils communication */}
                    <div className="filter_group">
                        <h4>Outils de communication</h4>
                        {["Téléphone", "SMS", "Email professionnel", "MSSanté", "Logiciel patient", "Visio / Teams", "Secrétariat"]
                            .map(item => (
                                <label key={item}>
                                    <input
                                        type="checkbox"
                                        onChange={(e) => {
                                            const updated = e.target.checked
                                                ? [...filters.patientComTool, item]
                                                : filters.patientComTool.filter(i => i !== item);

                                            setFilters({ ...filters, patientComTool: updated });
                                        }}
                                    />
                                    {item}
                                </label>
                            ))}
                    </div>

                    {/* Contact */}
                    <div className="filter_group">
                        <h4>Modalités de contact</h4>
                        {["Téléphone direct", "Téléphone secrétariat", "SMS", "Email professionnel", "MSSanté", "Logiciel patient", "Impossible dans ce délai"]
                            .map(item => (
                                <label key={item}>
                                    <input
                                        type="checkbox"
                                        onChange={(e) => {
                                            const updated = e.target.checked
                                                ? [...filters.urgentContact, item]
                                                : filters.urgentContact.filter(i => i !== item);

                                            setFilters({ ...filters, urgentContact: updated });
                                        }}
                                    />
                                    {item}
                                </label>
                            ))}
                    </div>

                    {/* Publics */}
                    <div className="filter_group">
                        <h4>Publics concernés</h4>
                        {["Sportifs", "Enfants", "Adolescents", "Femmes enceintes", "Personnes âgées", "Personnes en situation de handicap", "Soins palliatifs", "Douleurs chroniques", "Troubles psy / anxiété"]
                            .map(item => (
                                <label key={item}>
                                    <input
                                        type="checkbox"
                                        onChange={(e) => {
                                            const updated = e.target.checked
                                                ? [...filters.targetAudiences, item]
                                                : filters.targetAudiences.filter(i => i !== item);

                                            setFilters({ ...filters, targetAudiences: updated });
                                        }}
                                    />
                                    {item}
                                </label>
                            ))}
                    </div>

                </div>
            )}

            {filteredUsers.length !== 0 ? (
                <ul className="list_users">
                    {filteredUsers.map((user, idx) => (
                        <li className="onglet" onClick={() => setShowProfil(user)} key={idx}>
                            <p><span>Profession :</span> {user.profession}</p>
                            <p><span>Nom et Prénom :</span> {user.lastName} {user.firstName}</p>
                            <p><span>Lieu d'exercice :</span> {user.mainLocation}</p>
                            <p><span>Note :</span> {user.importantInfo || 'Aucune note'}</p>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="not_found">Aucun résultat</p>
            )}

            {showProfil &&
                <div className="mdl_show_more">
                    <button className="close" onClick={() => setShowProfil(null)}>
                        <i className="fas fa-xmark"></i>
                    </button>

                    <div className="content">
                        <h2>Fiche Personnelle Annuaire PSOA</h2>

                        <div className="lists">
                            <ul>
                                <li><h3>Identité du professionnel</h3></li>
                                <li><span>Nom et Prénom :</span> <p>{showProfil.lastName} {showProfil.firstName}</p></li>
                                <li><span>Profession :</span> <p>{showProfil.profession}</p></li>
                                <li><span>Lieu d’exercice :</span> <p>{showProfil.mainLocation}</p></li>
                                <li><span>Adresse professionnelle :</span> <p>{showProfil.access ? (showProfil.secondaryLocations || 'Aucune données') : 'Données privée'}</p></li>
                            </ul>
                            <ul>
                                <li><h3>Coordonnées du professionnel</h3></li>
                                <li><span>Téléphone direct :</span> <p>{showProfil.access ? (showProfil.proPhone || 'Aucune données') : 'Données privée'}</p></li>
                                <li><span>Téléphone secrétariat :</span> <p>{showProfil.access ? (showProfil.secretaryPhone || 'Aucune données') : 'Données privée'}</p></li>
                                <li><span>Email professionnel :</span> <p>{showProfil.access ? (showProfil.proEmail || 'Aucune données') : 'Données privée'}</p></li>
                                <li><span>Email professionnel sécurisé :</span> <p>{showProfil.access ? (showProfil.secureProEmail || 'Aucune données') : 'Données privée'}</p></li>
                            </ul>
                            <ul>
                                <li><h3>Outils de communication</h3></li>

                                {[
                                    { label: "Au sujet d’un patient :", items: showProfil.patientComTool || [], other: showProfil.otherPatientComTool || '' },
                                    { label: "Les échanges administratifs :", items: showProfil.adminComTool || [], other: showProfil.otherAdminComTool || '' },
                                    { label: "Avis ou un conseil interprofessionnel :", items: showProfil.interproTool || [], other: showProfil.otherInterproTool || '' },
                                    { label: "Pour organiser une réunion :", items: showProfil.meetingTool || [], other: showProfil.otherMeetingTool || '' }
                                ].map((category, catIdx) => (
                                    <li key={catIdx}>
                                        <span>{category.label}</span>
                                        {category && category.items.length > 0 &&
                                            <p>
                                                {category.items.length > 0 && category.items.map((e, idx) =>
                                                    e !== 'AUTRE' && <t key={idx}>{e}{idx !== category.items.length - 1 && ','}</t>
                                                )}
                                                {category.other && <t>{category.other}</t>}
                                            </p>
                                        }
                                        {category.items.length === 0 && <p>{showProfil.access ? 'Aucune données' : 'Données privée'}</p>}
                                    </li>
                                ))}
                            </ul>
                            <ul>
                                <li><h3>Modalités de contact</h3></li>

                                {[
                                    { label: "En cas d’urgence (< 2 heures) :", items: showProfil.urgentContact || [], other: showProfil.otherUrgentContact || '' },
                                    { label: "Pour une réponse sous 24 heures :", items: showProfil.dailyContact || [], other: showProfil.otherDailyContact || '' },
                                    { label: "Pour un délai d’environ une semaine :", items: showProfil.weeklyContact || [], other: showProfil.otherWeeklyContact || '' }
                                ].map((category, catIdx) => (
                                    <li key={catIdx}>
                                        <span>{category.label}</span>
                                        {category && category.items.length > 0 &&
                                            <p>
                                                {category.items.length > 0 && category.items.map((e, idx) =>
                                                    e !== 'AUTRE' && <t key={idx}>{e}{idx !== category.items.length - 1 && ','}</t>
                                                )}
                                                {category.other && <t>{category.other}</t>}
                                            </p>
                                        }
                                        {category.items.length === 0 && <p>{showProfil.access ? 'Aucune données' : 'Données privée'}</p>}
                                    </li>
                                ))}
                            </ul>
                            <ul>
                                <li><h3>Informations attendues</h3></li>

                                <li><span>Informations attendues du médecin :</span> <p>{showProfil.access ? (showProfil.infoExpected?.ide || 'Aucune données') : 'Données privée'}</p></li>
                                <li><span>Informations attendues du pharmacien :</span> <p>{showProfil.access ? (showProfil.infoExpected?.pharmacist || 'Aucune données') : 'Données privée'}</p></li>
                                <li><span>Informations attendues de l’Infirmier / IDE :</span> <p>{showProfil.access ? (showProfil.infoExpected?.physiotherapist || 'Aucune données') : 'Données privée'}</p></li>
                            </ul>
                            <ul>
                                <li><h3>Informations importantes</h3></li>

                                <li>
                                    <span>Publics de prédilection :</span>

                                    {showProfil.targetAudiences && showProfil.targetAudiences.length > 0 &&
                                        <p>
                                            {showProfil.targetAudiences && showProfil.targetAudiences.length > 0 && showProfil.targetAudiences.map((e, idx) => e !== 'AUTRE' &&
                                                <t key={idx}>{e}{idx !== showProfil.targetAudiences.length - 1 && ','}</t>
                                            )}
                                            {showProfil.otherTargetAudiences && <t>{showProfil.otherTargetAudiences}</t>}
                                        </p>
                                    }

                                    {!showProfil.targetAudiences && <p>Données privée</p>}
                                </li>
                                <li><span>Notes importantes :</span> <p>{showProfil.importantInfo}</p></li>
                            </ul>
                        </div>

                        {!showProfil.access && <button className="btn_request_full_profil" onClick={() => requestAccess(showProfil._id)}>Demander à voir la fiche complète</button>}
                    </div>
                </div>
            }
        </div>
    )
}

export default Home;